export default __webpack_public_path__ + "static/media/linkedin.f64a1b7d.svg";